import React from 'react'
import './style.css';
export default function AppHeader({onLogoClick,onTabCLick,hideMenu = false}) {
    

    return (
        <div className='header-main'>
            <img onClick={onLogoClick} src={require("../../assets/images/logo.png")} className='header-logo-img' />  
            {!hideMenu &&
            <div className='header-tab-main'>
                <p onClick={()=> onTabCLick("ABOUT")}>ABOUT ME</p>
                <p onClick={()=> onTabCLick("WORK")}>WORK</p>
                <p onClick={()=> onTabCLick("CONTACT")}>CONTACT</p>
            </div>}
        </div>
    )
}
